module.exports = __webpack_public_path__ + "img/0Q3A5610_L_WoodMatted_MockedUp.e1ed49ed.jpg";